import { render, staticRenderFns } from "./login-hb.vue?vue&type=template&id=4a403972&scoped=true"
import script from "./login-hb.vue?vue&type=script&lang=js"
export * from "./login-hb.vue?vue&type=script&lang=js"
import style0 from "./login-hb.vue?vue&type=style&index=0&id=4a403972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a403972",
  null
  
)

export default component.exports